import React from 'react';
import './index.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Customers from './pages/Customers';
import Competence from './pages/Competence';
import AboutGrovv from './pages/AboutGrovv';
import ScrollToTop from './components/ScrollToTop';
import Services from './pages/Services';
import BlogMesManufacturing from './pages/BlogMesManufacturing';
import BlogSapAI from './pages/BlogSapAI';
import BlogSapFiori from './pages/BlogSapFiori';
import BlogITvsOT from './pages/BlogITvsOT';
import BlogManufacturingIntegration from './pages/BlogManufacturingIntegration';
import BlogSchneiderElectricHebrew from './pages/BlogSchneiderElectricHebrew';
import LowCodeWithAi from './pages/LowCodeWithAi';

function App() {
  return (
    <Router>
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          {/* The old demo-request form posted to a template endpoint; requests now go through Contact. */}
          <Route path="/get-demo" element={<Contact />} />
          <Route path="/Customers" element={<Customers />} />
          <Route path="/Competence" element={<Competence />} />
          <Route path="/About" element={<AboutGrovv />} />
          <Route path="/aboutGrovv" element={<AboutGrovv />} />
          <Route path="/services" element={<Services />} />
          <Route path="/Blog" element={<Blog />} />
          <Route path="/BlogMesManufacturing" element={<BlogMesManufacturing />} />
          <Route path="/BlogSapAI" element={<BlogSapAI />} />
          <Route path="/BlogSapFiori" element={<BlogSapFiori />} />
          <Route path="/BlogITvsOT" element={<BlogITvsOT />} />
          <Route path="/LowCodeWithAi" element={<LowCodeWithAi />} />
          <Route path="/BlogManufacturingIntegration" element={<BlogManufacturingIntegration />} />
          <Route path="/BlogSchneiderElectricHebrew" element={<BlogSchneiderElectricHebrew />} />
          {/* Retired routes (careers, partners, job pages) and typos land on the home page with its own URL. */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ScrollToTop>
    </Router>
  );
}

export default App;
